import axios from "axios";

export default function sendEmail(html, subject, toemail,cc) {
  axios
    .get(`${process.env.REACT_APP_API_SERVER_URL}/admin-details`)
    .then((response) => {
      axios.post(`${process.env.REACT_APP_API_SERVER_URL}/send-email`, {
        html: html,
        subject: subject,
        toemail: toemail ? toemail : response.data[0].value,
        cc: cc ? cc : ''
      });
    });
}
